import CommentInput from "./CommentInput";
import Comments from "./Comments";

const RadioComments = () => {
    return (
        <div className="radio-comments">
            <Comments/>
            <CommentInput/>
        </div>
      );
}
 
export default RadioComments;